// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__KLA3u","inner":"Footer_inner__741c_"};